module.exports = __webpack_public_path__ + "static/img/smart_venues_bg.a288462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart_venues_bg.png
// module id = 6dvo
// module chunks = 1